import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable()
export class TrackingService {

    private host: any = {};

    constructor(private client: HttpClient) {
        this.host['v2-tracking'] = environment.host('v2-tracking');
        this.host['v1-tracking'] = environment.host('v1-tracking');
        this.host['v2-sleep'] = environment.host('v2-sleep');
        this.host['v1-sleep'] = environment.host('v1-sleep');
    }

    getV2TrackingDataOfYearByDay(accountId: string, data: string, year: number): Observable<any> {
        return this.client.request('GET', `${this.host['v2-tracking']}/v2/tracking/${data}/${accountId}/data/of-year/${year}/by-day`, {
            headers: { 'X-MyKronoz-Authorization': `v2;admin` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('TrackingService.getV2TrackingDataOfYearByDay.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('TrackingService.getV2TrackingDataOfYearByDay.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2TrackingDataOfWeekByHour(accountId: string, data: string, week: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-tracking']}/v2/tracking/${data}/${accountId}/data/of-week/${week}/by-hour`, {
            headers: { 'X-MyKronoz-Authorization': `v2;admin` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('TrackingService.getV2TrackingDataOfWeekByHour.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('TrackingService.getV2TrackingDataOfWeekByHour.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2TrackingDataOfDayBy5Minutes(accountId: string, data: string, day: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-tracking']}/v2/tracking/${data}/${accountId}/data/of-day/${day}/by-5-minutes`, {
            headers: { 'X-MyKronoz-Authorization': `v2;admin` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('TrackingService.getV2TrackingDataOfDayBy5Minutes.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('TrackingService.getV2TrackingDataOfDayBy5Minutes.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2SleepSummaryOfMonth(accountId: string, month: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-sleep']}/v2/sleep/${accountId}/summary/of-month/${month}`, {
            headers: { 'X-MyKronoz-Authorization': `v2;admin` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('TrackingService.getV2SleepSummaryOfMonth.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('TrackingService.getV2SleepSummaryOfMonth.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2SleepDataOfWeek(accountId: string, week: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-sleep']}/v2/sleep/${accountId}/data/of-week/${week}`, {
            headers: { 'X-MyKronoz-Authorization': `v2;admin` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('TrackingService.getV2SleepDataOfWeek.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('TrackingService.getV2SleepDataOfWeek.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getLastYearTrackingData(accountId: string): Observable<any> {
        let d: Date = new Date(Date.now());
        d = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        d.setDate(d.getDate() + 1);

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));
        let date: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        return this.client.request('GET', `${this.host['v1-tracking']}/v1/data/tracking/activities/summary/${date}/1y`, {
            headers: { 'X-MyKronoz-Authorization': `account=${accountId}` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('TrackingService.getLastYearTrackingData.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('TrackingService.getLastYearTrackingData.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getLastYearHourlyTrackingDataByActivity(activity: string, accountId: string): Observable<any> {
        let d: Date = new Date(Date.now());
        d = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        d.setDate(d.getDate() + 2);

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));
        let toDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        d.setMonth(d.getMonth() - 12);
        let fromDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        return this.client.request('GET', `${this.host['v1-tracking']}/v1/data/tracking/activities/hourly/${activity}/range/${fromDate}/${toDate}`, {
            headers: { 'X-MyKronoz-Authorization': `account=${accountId}` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('TrackingService.getLastYearDurationData.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('TrackingService.getLastYearDurationData.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getWeeklyHourTrackingDataByActivity(activity: string, accountId: string, fromDate: string, toDate: string) {

        let d: Date;
        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));

        d = new Date(Date.parse(fromDate));
        fromDate = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        d = new Date(Date.parse(toDate));
        toDate = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        return this.client.request('GET', `${this.host['v1-tracking']}/v1/data/tracking/activities/hourly/${activity}/range/${fromDate}/${toDate}`, {
            headers: { 'X-MyKronoz-Authorization': `account=${accountId}` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('TrackingService.getLastYearDurationData.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('TrackingService.getLastYearDurationData.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getLastYearHeartRateData(accountId: string): Observable<any> {
        let d: Date = new Date(Date.now());
        d = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        d.setDate(d.getDate() + 1);

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));
        let date: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        return this.client.request('GET', `${this.host['v1-tracking']}/v1/data/tracking/activities/daily/AVGRATE/${date}/1y`, {
            headers: { 'X-MyKronoz-Authorization': `account=${accountId}` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('TrackingService.getLastYearHeartRateData.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('TrackingService.getLastYearHeartRateData.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getDailyMinuteHeartRateData(accountId: string, day: string): Observable<any> {
        let d: Date = new Date(Date.parse(day));

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));
        let date: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        return this.client.request('GET', `${this.host['v1-tracking']}/v1/data/tracking/activities/minute/AVGRATE/${date}`, {
            headers: { 'X-MyKronoz-Authorization': `account=${accountId}` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('TrackingService.getDailyMinuteHeartRateData.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('TrackingService.getDailyMinuteHeartRateData.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getLastYearSleepData(accountId: string): Observable<any> {
        let d: Date = new Date(Date.now());
        d = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        d.setDate(d.getDate() + 1);

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));
        let date: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        return this.client.request('GET', `${this.host['v1-sleep']}/v1/data/sleep/_/${date}/1y?withDetail=false`, {
            headers: { 'X-MyKronoz-Authorization': `account=${accountId}` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('TrackingService.getLastYearSleepData.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('TrackingService.getLastYearSleepData.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getWeekSleepData(accountId: string, day: string): Observable<any> {
        let d: Date = new Date(Date.parse(day));
        d = new Date(d.getFullYear(), d.getMonth(), d.getDate());

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));
        let date: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        return this.client.request('GET', `${this.host['v1-sleep']}/v1/data/sleep/_/${date}/7d?withDetail=true`, {
            headers: { 'X-MyKronoz-Authorization': `account=${accountId}` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('TrackingService.getWeekSleepData.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('TrackingService.getWeekSleepData.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }
}
